import React, { useState } from 'react';
import { Box, Grid, Tab, Tabs } from '@mui/material';
import { makeStyles } from '@mui/styles';
import useStyles from './useStyles';
import PurchasesExams from './Exams';

const useStyle = makeStyles(() => ({
  root: {
    width: '100% !important',
  },
}));

function PurchasesCourses() {
  return (
    <Grid container mt={2} spacing={3}>
      Comming soon..
    </Grid>
  );
}

const Purchases = () => {
  const classes = useStyles();
  const styles = useStyle();

  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => setTabValue(newValue);

  return (
    <Box className={classes.mainContainer}>
      <Tabs
        color='primary'
        classes={{ root: styles.root }}
        value={tabValue}
        onChange={handleChange}
        variant='scrollable'
        scrollButtons='auto'
        aria-label='scrollable auto tabs example'
      >
        <Tab label='تست ها' />
        <Tab label='دوره ها' disabled />
      </Tabs>
      {tabValue === 1 ? <PurchasesCourses /> : <PurchasesExams />}
    </Box>
  );
};

export default Purchases;
